import React from "react";

const RemoveAutoApproveBankCandiate = ({ cls }) => {
  return (
    <svg
      width="16"
      height="17"
      className={cls}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        d="M18,12c-3.309,0-6,2.691-6,6s2.691,6,6,6,6-2.691,6-6-2.691-6-6-6Zm4,6c0,.74-.216,1.424-.567,2.019l-5.452-5.453c.595-.351,1.279-.567,2.019-.567,2.206,0,4,1.794,4,4Zm-8,0c0-.74,.216-1.424,.567-2.019l5.452,5.453c-.595,.351-1.279,.567-2.019,.567-2.206,0-4-1.794-4-4Zm-5-6c3.309,0,6-2.691,6-6S12.309,0,9,0,3,2.691,3,6s2.691,6,6,6Zm0-10c2.206,0,4,1.794,4,4s-1.794,4-4,4-4-1.794-4-4,1.794-4,4-4Zm2.079,12c-.358,.618-.629,1.292-.811,2H5c-1.654,0-3,1.346-3,3v5H0v-5c0-2.757,2.243-5,5-5h6.079Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RemoveAutoApproveBankCandiate;
